// extracted by mini-css-extract-plugin
export default {"primaryColor":"#354760","white":"#fff","container":"styles_container__ht8XS","input":"styles_input__RLGSF"};